import { render, staticRenderFns } from "./labelOrderStatusBadge.vue?vue&type=template&id=4b81fba0&"
import script from "./labelOrderStatusBadge.vue?vue&type=script&lang=js&"
export * from "./labelOrderStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports